import pseudoTranslate from '@nike/i18n-pseudo';
import localeMap from '../utils/locale-map';
/**
 * Performs all logic necessary to output a given date in the intended format.
 * This method also performs all logic necessary for different browsers.
 * @param {string} locale - The BCP-47 locale of the intended format
 * @param {Date} date - The date object to format
 * @param {object} options - The options to pass along to the native object
 * @return {string} Return
 */
export default function dateTimeFormat(locale, date, options = {}) {
    const finalOpts = options;
    let finalLocale = locale;
    // Removing any options that were given a null value. This mostly
    // comes from the React component
    Object.keys(finalOpts)
        .filter((key) => finalOpts[key] === null)
        .forEach((key) => delete finalOpts[key]);
    // Map this locale if necessary
    if (Object.keys(localeMap).includes(locale)) {
        finalLocale = localeMap[locale];
    }
    let dateOutput = new Intl.DateTimeFormat(finalLocale, finalOpts).format(date);
    // Apply pseudo if necessary
    if (locale === 'pseudo') {
        dateOutput = pseudoTranslate(dateOutput);
    }
    return dateOutput;
}
//# sourceMappingURL=date-time.js.map